import styled from 'styled-components'

export const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  padding: 1rem 40px;
`

export const PageContent = styled.main`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`
